import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import OptionRow from 'components/Meteorology/Shared/ControlPanelSheet/OptionRow';
import { Runtime } from 'helper/products/synopticCharts';
import { selectRuntime, setRuntime } from 'redux/reducers/synopticChartsReducer';
import useGetOptions from 'utils/hooks/synopticCharts/useGetOptions';

export default function RuntimeSection() {
  const dispatch = useDispatch();
  const { runtimes } = useGetOptions();
  const runtime: Runtime | undefined = useSelector(selectRuntime);

  if (!runtimes || runtimes.length === 0) {
    return <p className="sc-mobile-panel-hint">Carregando runtimes...</p>;
  }

  return (
    <>
      {runtimes.map((option) => (
        <OptionRow
          key={option.id}
          label={option.label}
          selected={runtime?.id === option.id}
          onSelect={() => dispatch(setRuntime(option))}
        />
      ))}
    </>
  );
}
